import React, { useState } from 'react';
import * as Styles from '../style';
import { Icon } from 'semantic-ui-react';
import { H4, P } from 'components/reusable-css';
import CustomButton from 'components/common/custom-button';
import { useMutation, useQuery } from 'react-query';
import { ADD_RULES, DELETE_ALL_RULES } from '../queries';
import { mutationProps } from 'utils/custom-hook';
import Loading from 'components/common/loading';
import { Trans, useTranslation } from 'react-i18next';
import RulesCardList from './RulesCardList';
import CustomInput from 'components/input';
import { useSelector } from 'react-redux';

const CreateTemplatePanel = ({ isClose, item_id, label, mainRefectch, isOpenCreateObj, setIsOpenCreateObj }) => {
  const { t } = useTranslation();
  const [isEdit, setIsEdit] = useState(false);
  const [editLabel, setEditLabel] = useState(label);
  const userAccount = useSelector((state) => state.user.account);
  const {
    data: firewallRuleSet,
    isLoading,
    refetch,
    isRefetching,
  } = useQuery(`/vs/firewall/${item_id}`, {
    onSuccess: (res) => {
      setRuleSetArr(res?.firewall_ruleset_rules);
    },
  });
  const { data: firewallServies, isLoading: firewallServicesLoading } = useQuery(`/vs/firewall/services`);
  const { mutate: vsFirewallAction, isLoading: vsFirewallActionLoading } = useMutation(DELETE_ALL_RULES);
  const { data: protocolsArr, isLoading: isLoadingProtocol } = useQuery('/vs/firewall/protocols');
  const { data: objectArr, isLoading: isLoadingObject } = useQuery(`/vs/firewall/object`);
  const [ruleSetArr, setRuleSetArr] = useState(undefined);

  const handleCommit = async () => {
    await vsFirewallAction(
      {
        id: item_id,
        action: 'clear',
      },
      mutationProps(
        false,
        {
          onSuccess: async () => {
            try {
              const promises = [];
              const filterDeletedArray = ruleSetArr?.filter((data) => data.isDeleted != 1);
              const reOrdered = filterDeletedArray.map((rule, idx) => ({
                ...rule,
                order: idx + 1,
              }));
              for (const key in reOrdered) {
                const object = reOrdered[key];
                const promise = await ADD_RULES(object, item_id);
                promises.push(promise);
              }
              promises.length > 0 && (await Promise.all(promises));
              await vsFirewallAction(
                {
                  id: item_id,
                  action: 'commit',
                },
                mutationProps(
                  false,
                  {
                    onSuccess: () => {
                      refetch();
                      mainRefectch();
                    },
                  },
                  t,
                ),
              );
            } catch (error) {
              console.log(error);
            }
          },
        },
        t,
      ),
    );
  };

  const handleCloseModal = () => {
    isClose();
    setRuleSetArr([]);
  };

  if (isLoading || firewallServicesLoading || ruleSetArr == undefined || isLoadingProtocol || isLoadingObject) {
    return <Loading gap={50} />;
  }

  const isChange = JSON.stringify(ruleSetArr) === JSON.stringify(firewallRuleSet?.firewall_ruleset_rules);
  const handleEditLabel = (e) => {
    setEditLabel(e.target.value);
  };

  return (
    <Styles.SettingPanel>
      <Styles.Header>
        <Styles.CrossIcon>
          <Icon size="large" name="close" onClick={handleCloseModal} />
        </Styles.CrossIcon>
        {isEdit ? (
          <Styles.Start>
            <div style={{ display: 'flex' }}>
              <CustomInput
                type={'text'}
                className="custom_inputs"
                name={'label'}
                value={editLabel}
                placeholder={t('account/usermgmt.string16')}
                onChange={(e) => handleEditLabel(e)}
                isFormIk={false}
                onEnter={(e) => {
                  handleEditLabel(e);
                  setIsEdit(false);
                }}
                styling={{ marginTop: '-3em', marginBottom: 0 }}
              />
            </div>
            <Icon size="large" name="pencil" />
          </Styles.Start>
        ) : (
          <Styles.Start onClick={() => setIsEdit(false)}>
            <H4>{editLabel}</H4>
            <Icon size="large" name="pencil" />
          </Styles.Start>
        )}
      </Styles.Header>
      <Styles.Content>
        <RulesCardList
          isLoading={isLoading}
          firewallServies={firewallServies}
          ruleSetArr={ruleSetArr}
          setRuleSetArr={setRuleSetArr}
          protocolsArr={protocolsArr}
          objectArr={objectArr}
          isRefetching={isRefetching}
          isOpenCreateObj={isOpenCreateObj}
          setIsOpenCreateObj={setIsOpenCreateObj}
        />
        <Styles.ObjectIpListFlex>
          <CustomButton
            isLoading={vsFirewallActionLoading || isRefetching}
            disabled={vsFirewallActionLoading || isChange || isRefetching}
            title={'vs/firewall.string81'}
            onClick={refetch}
            buttonStyles={{ marginBottom: '10px' }}
          />
          <CustomButton
            title={'vs/firewall.string14'}
            onClick={handleCommit}
            disabled={vsFirewallActionLoading || isChange || isLoading || isRefetching}
            isLoading={vsFirewallActionLoading || isLoading}
            buttonStyles={{ marginLeft: '10px', marginBottom: '10px' }}
          />
        </Styles.ObjectIpListFlex>
        <Styles.NewflexContainer>
          <Styles.BlueInfo>
            <Icon name="lightbulb" />
            <P>
              <Trans
                i18nKey="vs/firewall.string15"
                components={{
                  add: (
                    <span
                      style={{
                        fontSize: '20px',
                        padding: '0 7px',
                        backgroundColor: '#59c025',
                        borderRadius: '50%',
                        margin: '0 2px',
                      }}
                    />
                  ),
                }}
              />
            </P>
          </Styles.BlueInfo>
        </Styles.NewflexContainer>
        <Styles.flexContainer>
          <Styles.BlueInfo>
            <Icon name="lightbulb" />
            <P>{t('vs/firewall.string13', { ip: userAccount?.your_ip })}</P>
          </Styles.BlueInfo>
        </Styles.flexContainer>
      </Styles.Content>
    </Styles.SettingPanel>
  );
};

export default CreateTemplatePanel;
